import React, { Component } from "react"
import { Manager, Reference, Popper } from "react-popper"
import styled from "@emotion/styled"

const DropDownContainer = styled.div`
  border-radius: 4px;
  background: ${props => (props.darkMode ? props.theme.gray12 : "white")};
  border: 1px solid ${(props) => (props.darkMode ? props.theme.gray10 : props.theme.gray1)};
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`

class PopperContainer extends Component {
  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  componentWillMount() {
    document.addEventListener("mousedown", this.handleClick, false)
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick, false)
  }

  handleClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return
    }

    if (this.props.onClickOutside) {
      this.props.onClickOutside(e)
    }
  }

  render() {
    const {
      darkMode,
      className,
      display,
      displayDisplay = "inline-block",
      placement,
      modifiers,
      positionFixed,
      show,
      disabled,
      hideOutOfBoundaries,
      children,
      offset = false
    } = this.props
    return (
      <div className={className} ref={(c) => { this.node = c }}>
        <Manager>
          <Reference>
            {({ ref }) => (
              <span style={{ display: displayDisplay }} ref={ref}>
                {display}
              </span>
            )}
          </Reference>
          {show ?
            <Popper
              placement={placement}
              modifiers={modifiers}
              positionFixed={positionFixed}
              disabled={disabled}
            >
              {({
                ref, style, placement, arrowProps, outOfBoundaries, scheduleUpdate
              }) => {
                this.scheduleUpdate = scheduleUpdate
                if (outOfBoundaries && hideOutOfBoundaries) {
                  return null
                }
                return (
                  <div className="popper-dropdown" ref={ref} style={{ ...style, zIndex: 8999, ...offset }} data-placement={placement}>
                    <DropDownContainer
                      darkMode={darkMode}
                      className="dropdown-container"
                    >
                      {children}
                    </DropDownContainer>
                  </div>
                )
              }}
            </Popper>
            :
            null
          }
        </Manager>
      </div>
    )
  }
}

export default PopperContainer
